import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/DictApi/';
export const queryAirTypeList = (data)=>{
  return getInterface.post(`${prefixUrl}queryAirTypeList`, data);
}
export const queryDictDataListByType = (data)=>{
  return getInterface.post(`${prefixUrl}queryDictDataListByType`, data);
}
// 飞机舰船类型
export const getAllAirAndWarshipType = (data)=>{
  return getInterface.post(`${prefixUrl}getAllAirAndWarshipType`, data);
}